let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("49weW")).then(() => parcelRequire('dAq4f'));